/* eslint-disable  */
export const contactInfo = {
    phone: '+1 (406) 299-2944',
    email: 'sagemountainhealth@gmail.com',
    address: '1341 Harrison Ave Butte MT 59701 Suite #15',
    // website: 'www.website.com',
};
